"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
var _user = require("@/api/system/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "sendActivationEmail",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    sendActivationEmailUsername: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('login.userError')));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: '',
        email: ''
      },
      rules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        email: [{
          required: true,
          message: this.$t('home.messageSix'),
          trigger: 'blur'
        }, {
          required: true,
          type: 'email',
          message: this.$t('home.messageThree'),
          trigger: ['blur', 'change']
        }]
      },
      msg: ""
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  methods: {
    opened: function opened() {
      this.form.username = this.sendActivationEmailUsername;
    },
    handleClose: function handleClose() {
      this.$parent.sendActivationEmailVisible = false;
    },
    sendActivationEmail: function sendActivationEmail() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.loading = (0, _utils.load)();
          (0, _user.resendActivationEmail)(_this2.form.username, _this2.form.email).then(function (res) {
            _this2.loading.close();
            if (res.success) {
              var successMessage = res.data;
              if (!successMessage) {
                successMessage = _this2.$t('home.sentEmailSuccess');
              }
              _this2.$message({
                message: successMessage.replace(/\r?\n/g, '<br>'),
                type: 'success',
                dangerouslyUseHTMLString: true
              });
              _this2.handleClose();
            } else {
              var errorMessages = res.errorMessages && res.errorMessages[0];
              if (!errorMessages) {
                errorMessages = _this2.$t('home.sentEmailFail');
              }
              _this2.$message({
                message: errorMessages.replace(/\r?\n/g, '<br>'),
                type: 'warning',
                dangerouslyUseHTMLString: true
              });
            }
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    }
  }
};